import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../document.service';
import { Document } from '../document';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-document-create',
  templateUrl: 'create.component.html',
})
export class DocumentCreateComponent implements OnInit {
  /**
   * Details of the document being created.
   */
  public document: Document;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {DocumentService} documentService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private documentService: DocumentService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.documentService.loading.subscribe(result => (this.isLoading = result));
  }

  /**
   * Initialise the component, creating a new blank document if required.
   */
  public ngOnInit(): void {
    if (!this.document) {
      this.document = new Document();
    }
  }

  /**
   * Perform the create action which adds the new document into the backend.
   */
  public create() {
    const createDocument = this.documentService
      .createDocument(this.document)
      .subscribe(
        (result: Document) => {
          this.notificationService.success(
            `Document Created`,
            `New document ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.document = new Document();
          createDocument.unsubscribe();
          this.router.navigate(['/documents']);
        },
        err => {
          this.notificationService.error(
            `Could not create Document`,
            err.error.message,
            10,
          );
        },
      );
  }
}
